/**
 * Route-transition loading skeleton (wired as defaultPendingComponent). Shows
 * during pending route transitions (when a route's beforeLoad/loader is async)
 * instead of a blank flash — Phase-0 acceptance: "loading → skeleton, not flash".
 * Routes are synchronous today; this activates as routes gain data loaders.
 */
export function ShellPending() {
  return (
    <div
      aria-busy="true"
      aria-live="polite"
      aria-label="Loading view"
      className="flex flex-col gap-3 p-8 animate-pulse"
      data-testid="shell-pending"
    >
      <span className="sr-only">Loading…</span>
      {/* Wave 4 (§4.3): skeleton mirrors the real page hierarchy — title row, facet-tab row,
          then content lines — so the pending frame reads as the page it becomes, not four
          arbitrary bars. Purely visual; boundary wiring untouched. */}
      <div className="h-6 w-64 rounded bg-[var(--color-surface-muted)]" />
      <div className="flex gap-2">
        <div className="h-4 w-20 rounded bg-[var(--color-surface-muted)]" />
        <div className="h-4 w-20 rounded bg-[var(--color-surface-muted)]" />
        <div className="h-4 w-20 rounded bg-[var(--color-surface-muted)]" />
      </div>
      <div className="mt-2 h-4 w-40 rounded bg-[var(--color-surface-muted)]" />
      <div className="h-4 w-52 rounded bg-[var(--color-surface-muted)]" />
      <div className="h-4 w-44 rounded bg-[var(--color-surface-muted)]" />
    </div>
  );
}
